module.exports = __webpack_public_path__ + "img/icon_lbsq.0c85eaff.png";